import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMobileComponent } from "./med-icon-mobile.component";

@NgModule({
  declarations: [
    MedIconMobileComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMobileComponent,
  ],
})
export class MedIconMobileModule { }
